import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';

declare var $;

@Injectable()
export class UsuariosService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/usuarios';
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'name': '',
      'clave': '',
      'email': '',
      'status': '',
      'cuentas': 1,
      'contador': 0,
      'exportacion': 1,
      'activo': 1,
      'temporal': '',
      'permisos_usuarios': []
    };
  }

  getUsuarios(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  getUsuariosDepositos(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  public searchUsuario(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  createUsuario(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  updateUsuario(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  deleteUsuario(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  getUsuariosPermisos() {
    return this.http.get(this.constantsService.apiURL + '/permisos', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(10, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateUsuario(data){
    console.log("validating... ", data);
    
    let error = [];

    // validacion de NOMBRE
    if(!this.validatorService.required(data["name"])){
      error["name"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["name"], 200)){
      error["name"] = this.errorService.max(200);
    }
    

    // validacion de EMAIL
    if(!this.validatorService.required(data["email"])){
      error["email"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["email"], 40)){
      error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }
    
    // validacion de CLAVE
    if(!this.validatorService.required(data["clave"])){
      error["clave"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["clave"], 50)){
      error["clave"] = this.errorService.max(50);
    }

    return error;
  }

  getCreadoresGastos() {
      return this.http.get(this.constantsService.apiURL + 'usuarios/creadores-gastos', this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/usuarios.service.ts